import type { LoaderFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import { z } from 'zod';
import { getMigrateMessagesPreview } from '~/modules/chat/api/get-migrate-messages-preview.server';

export const MIGRATE_MESSAGES_PREVIEW_API =
    '/remix-api/chat/migrate-messages-preview';

const QUERY_SCHEMA = z.object({
    id: z.coerce.number().int().positive(),
    afterID: z.coerce.number().int().positive().nullish(),
    after: z.coerce.number().int().nonnegative().nullish(),
});

/**
 * API endpoint to get conversation messages for the migrate messages preview.
 * Returns messages in ascending order for displaying which messages will be
 * migrated when inviting users to a 1-on-1 chat.
 * @see {@link packages/web/app/modules/chat/hooks/use-conversation-messages-preview.ts}
 */
export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    const { logger } = context;
    const url = new URL(request.url);
    const result = QUERY_SCHEMA.safeParse({
        id: url.searchParams.get('id'),
        afterID: url.searchParams.get('afterID'),
        after: url.searchParams.get('after'),
    });
    if (!result.success) {
        return routerData(null, { status: 400 });
    }

    try {
        const conversation = await getMigrateMessagesPreview({
            context,
            id: result.data.id,
            afterID: result.data.afterID ?? undefined,
            after: result.data.after ?? undefined,
        });

        return { conversation };
    } catch (error) {
        logger.error(`Error in ${MIGRATE_MESSAGES_PREVIEW_API}`, {
            error,
            data: result.data,
        });
        return routerData(null, { status: 500 });
    }
};
